import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';

import { P2 } from 'src/components/Typography';

export function PlaceholderText() {
  const { script } = React.useContext(FormParserContext);

  return <P2 className='padding-left-1p6'>{script.placeholderText}</P2>;
}
